(() => {
class AromautoAccountPanel extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.closeButton = this.querySelector('[data-aromauto-account-close]');
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyup = this.onKeyup.bind(this);
  }

  connectedCallback() {
    if (!this.details || !this.summary) return;
    this.summary.setAttribute('role', 'button');
    this.summary.setAttribute('aria-expanded', 'false');
    this.details.addEventListener('toggle', () => {
      const open = this.details.open;
      this.summary.setAttribute('aria-expanded', String(open));
      if (open) {
        document.querySelectorAll('aromauto-account-panel details[open]').forEach((details) => {
          if (details !== this.details) details.removeAttribute('open');
        });
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keyup', this.onKeyup);
      } else {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keyup', this.onKeyup);
      }
    });
    this.closeButton?.addEventListener('click', () => this.close());
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keyup', this.onKeyup);
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  onKeyup(event) {
    if (event.code?.toUpperCase() === 'ESCAPE') this.close();
  }

  close(returnFocus = true) {
    this.details?.removeAttribute('open');
    if (returnFocus) this.summary?.focus();
  }
}

class AromautoSearchModal extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.modal = this.querySelector('.aromauto-search__modal');
    this.closeButton = this.querySelector('.aromauto-panel-close');
    this.placeholder = document.createComment('aromauto-search-modal');
    this.onKeyup = this.onKeyup.bind(this);
    this.onOverlayClick = this.onOverlayClick.bind(this);
  }

  connectedCallback() {
    if (!this.details || !this.summary || !this.modal) return;
    this.summary.setAttribute('role', 'button');
    this.summary.setAttribute('aria-expanded', 'false');
    this.summary.addEventListener('click', (event) => {
      event.preventDefault();
      this.details.open ? this.close() : this.open();
    });
    this.closeButton?.addEventListener('click', () => this.close());
    this.modal.querySelector('.aromauto-modal-overlay')?.addEventListener('click', this.onOverlayClick);
  }

  disconnectedCallback() {
    this.close(false);
  }

  copySectionVariables() {
    const source = getComputedStyle(this.closest('.header-wrapper') || this);
    [
      '--aromauto-search-width',
      '--aromauto-search-radius',
      '--aromauto-account-width',
      '--aromauto-header-border',
      '--aromauto-header-text',
    ].forEach((property) => this.modal.style.setProperty(property, source.getPropertyValue(property)));
  }

  open() {
    if (this.details.open) return;
    this.copySectionVariables();
    this.modal.parentNode.insertBefore(this.placeholder, this.modal);
    document.body.appendChild(this.modal);
    this.details.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
    this.modal.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keyup', this.onKeyup);

    requestAnimationFrame(() => {
      const panel = this.modal.querySelector('[tabindex="-1"]');
      const input = this.modal.querySelector('input:not([type="hidden"])');
      if (typeof trapFocus === 'function' && panel) trapFocus(panel, input || panel);
      else input?.focus();
    });
  }

  close(returnFocus = true) {
    if (!this.details?.open && !this.modal?.classList.contains('is-open')) return;
    this.modal.classList.remove('is-open');
    this.details.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keyup', this.onKeyup);
    if (typeof removeTrapFocus === 'function') removeTrapFocus(returnFocus ? this.summary : null);
    else if (returnFocus) this.summary.focus();
    if (this.placeholder.parentNode) this.placeholder.parentNode.insertBefore(this.modal, this.placeholder);
    this.placeholder.remove();
  }

  onOverlayClick() {
    this.close();
  }

  onKeyup(event) {
    if (event.code?.toUpperCase() === 'ESCAPE') this.close();
  }
}

if (!customElements.get('aromauto-account-panel')) {
  customElements.define('aromauto-account-panel', AromautoAccountPanel);
}

if (!customElements.get('aromauto-search-modal')) {
  customElements.define('aromauto-search-modal', AromautoSearchModal);
}
})();
